<form (submit)="submit($event)" fxLayout="row" fxLayoutGap="10px">
  <section fxFlex="10">
    <mat-label>mortgage type:</mat-label>
    <mat-select id="contractType" [(value)]="contractType">
      <mat-option *ngFor="let contract of possibleContracts" [value]="contract.value">
        {{contract.label}}
      </mat-option>
    </mat-select>
  </section>

    <mat-form-field appearance="fill" fxFlex="10">
      <mat-label>mortage</mat-label>
      <input matInput id="mortgagedAmount" value="{{mortgagedAmount}}"
             (input)="mortgagedAmount= toNumber($event.target.value)"
      />
    </mat-form-field>

  <mat-form-field appearance="fill" fxFlex="5">
      <mat-label>Start Year</mat-label>
      <input matInput id="startYear" value="{{startYear}}"
             (input)="startYear= toNumber($event.target.value)"
      />
    </mat-form-field>

  <mat-form-field appearance="fill" fxFlex="5">
      <mat-label>Start Month</mat-label>
      <input matInput id="startMonth" value="{{startMonth}}"
             (input)="startMonth= toNumber($event.target.value)"
      />
    </mat-form-field>

    <mat-form-field appearance="fill" fxFlex="10">
      <mat-label>duration in years</mat-label>
      <input matInput id="durationInYears"
             value="{{durationInYears}}"
             (input)="durationInYears= toNumber($event.target.value)"
      />
    </mat-form-field>

    <mat-form-field appearance="fill" fxFlex="10">
      <mat-label>Interest Rate</mat-label>
      <input matInput id="interestRate"
             value="{{interestRate}}"
             (input)="interestRate= toNumber($event.target.value)"
      />
    </mat-form-field>

    <mat-form-field  appearance="fill" *ngIf="contractType=='SAVING'" fxFlex="20">
      <mat-label>Premium</mat-label>
      <input matInput id="premium"
             value="{{premium}}"
             (input)="premium= ( $event.target.value == null ||$event.target.value == '')? null : toNumber($event.target.value)"
      />
    </mat-form-field>

  <div fxFlex="{{(contractType=='SAVING')? 15 : 35}}" fxLayoutGap="10px">
    <button type="submit" mat-raised-button color="primary">calculate</button>
    <button *ngIf="isPaymentSupported()"
    type="button"
    mat-raised-button color="primary"
    matTooltip="Manage Payment"
    matBadge="{{paymentsCount}}"
    [matBadgeHidden]="paymentsCount == 0"
    (click)="addPaymentStrategy();">payments</button>
  </div>

  <div fxFlex="5">
    <button type="button"
            mat-fab color="accent"
            matTooltip="Remove Mortgage"
            (click)="remove()">-M
    </button>
  </div>
</form>
